import { profilesQueryOptions } from '@/hooks/api';
import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { ActionType, useI18n, useToast } from '@nosinovacao/nosid-mfe-common';
import { useQueryClient } from '@tanstack/react-query';

export function useDeleteProfile() {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { t } = useI18n();

  return useNosIdMutation({
    mutationFn: ({ sa, profileId }: { sa: string; profileId: string }) =>
      api.delete('/api/v1/profiles/:sa/:profileId', { params: { sa, profileId } }),
    errorLogAction: () => ({ ActionType: ActionType.DeleteProfile }),
    successLogAction: () => ({ ActionType: ActionType.DeleteProfile }),
    onSuccess: (_response, { sa, profileId }) => {
      queryClient.setQueryData(profilesQueryOptions(sa).queryKey, (old) =>
        (old ?? []).filter((p) => p.ProfileId !== profileId),
      );
      toast.show('success', t('Common.SnackBar.ProfileDeleted'));
    },
  });
}
